var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var BASE_PATH = '/czna-authorities';
/**
 * CZNA-298 — single source of truth mapping a top-level section path to its i18n
 * label id. Used to derive the left nav-pane header dynamically from the current
 * route (longest-prefix match), instead of the former hard-coded "Navigace".
 *
 * Order matters: more specific paths must precede their prefixes so the
 * longest-prefix match wins (none currently overlap, but keep this invariant).
 */
export var SECTION_LABELS = [
    { path: "".concat(BASE_PATH, "/proposals"), labelId: 'ui-czna-authorities.nav.proposals' },
    { path: "".concat(BASE_PATH, "/authorities"), labelId: 'ui-czna-authorities.nav.authorities' },
    { path: "".concat(BASE_PATH, "/headings"), labelId: 'ui-czna-authorities.nav.headings' },
    { path: "".concat(BASE_PATH, "/vocabularies"), labelId: 'ui-czna-authorities.nav.vocabularies' },
    { path: "".concat(BASE_PATH, "/inbox"), labelId: 'ui-czna-authorities.nav.inbox' },
    { path: "".concat(BASE_PATH, "/review-queue"), labelId: 'ui-czna-authorities.nav.reviewQueue' },
];
/** Settings sub-routes — being on one of these resolves to the "Nastavení" header. */
var SETTINGS_PATHS = [
    "".concat(BASE_PATH, "/import"),
    "".concat(BASE_PATH, "/settings"),
    "".concat(BASE_PATH, "/validation-rules"),
    "".concat(BASE_PATH, "/derivation-rules"),
    "".concat(BASE_PATH, "/semantic-catalog"),
    "".concat(BASE_PATH, "/help-texts"),
];
var SETTINGS_LABEL_ID = 'ui-czna-authorities.navigation.settings';
var matches = function (pathname, path) {
    return pathname === path || pathname.startsWith("".concat(path, "/"));
};
/**
 * Resolve the i18n label id for the nav-pane header from the current pathname.
 *
 * <p>Settings routes win first (collapsed to a single "Nastavení" header), then
 * the top-level section via longest-prefix match. Falls back to the generic
 * "Navigace" label when nothing matches.
 */
export var resolveNavSectionLabelId = function (pathname) {
    var _a;
    if (SETTINGS_PATHS.some(function (path) { return matches(pathname, path); })) {
        return SETTINGS_LABEL_ID;
    }
    var match = __spreadArray([], SECTION_LABELS, true).filter(function (section) { return matches(pathname, section.path); })
        .sort(function (a, b) { return b.path.length - a.path.length; })[0];
    return (_a = match === null || match === void 0 ? void 0 : match.labelId) !== null && _a !== void 0 ? _a : 'ui-czna-authorities.pane.navigation';
};
